import { RoomVariant } from "@/types/state";
import { Item, Phase, StrapiAsset } from "@/types/api";

export function getItemAssetVariant(item: Item, roomVariant: RoomVariant): StrapiAsset {
    if (roomVariant === "b" && item.asset_b) {
        return item.asset_b;
    }
    return item.asset_a;
}

export function getItemsFromPhase(phase: Phase): Item[] {
    const itemsMap = new Map<string, Item>();

    for (const message of phase.messages) {
        const responses = message?.Response ?? [];
        for (const response of responses) {
            if (!response) {
                continue;
            }

            if (response.item && !itemsMap.has(response.item.documentId)) {
                itemsMap.set(response.item.documentId, response.item);
            }

            if (response.followUpMessage) {
                const infoResponses = response.followUpMessage.Response ?? [];
                for (const infoResponse of infoResponses) {
                    if (infoResponse?.item && !itemsMap.has(infoResponse.item.documentId)) {
                        itemsMap.set(infoResponse.item.documentId, infoResponse.item);
                    }
                }
            }
        }
    }

    return Array.from(itemsMap.values());
}
